import getConfig from "@base/lib/config";

export function isTokenExpired(decodedToken) {
  try {
    const { exp } = decodedToken;
    const now = Date.now() / 1000;
    return exp < now;
  } catch {
    return true; // Treat as expired if decoding fails
  }
}

export async function getNewPublicTokenData() {
// changes here should also be reflected in usePublicToken.query.js
  const response = await fetch(`${getConfig('REACT_APP_REMOTE_URI')}graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
        mutation publicToken {
          createPublicToken {
            Token
            PDToken
            Version
            Message
            Organisations {
              ID
            }
            Member {
              ID
              Email
              Name
              FirstName
              Surname
              UserType
              AvatarMedia {
                URL
                TusID
              }
            }
          }
        }
      `,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to refresh token');
  }

  const { data, errors } = await response.json();
  if (errors || !data?.createPublicToken?.Token) {
    throw new Error('Invalid token response');
  }

  return data;
}